import { SVGAttributes } from 'react';

export default function (props: SVGAttributes<SVGElement>) {
    return (
        <svg width="17px" height="17px" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g
                id="Content-/-Tile"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <g
                    id="Content-/-Tile-/-Default-/-Rental-unit"
                    transform="translate(-282.000000, -305.000000)"
                    fillRule="nonzero"
                    stroke="#FFFFFF"
                    strokeWidth="1.5"
                >
                    <g
                        id="Actions-/-Button-/-Primary-/-Large-/-With-Icon"
                        transform="translate(271.000000, 300.000000)"
                    >
                        <g id="Group" transform="translate(12.000000, 0.000000)">
                            <g transform="translate(0.000000, 6.000000)" id="button-play">
                                <circle id="Oval" cx="8" cy="7.99866667" r="7.5" />
                                <path
                                    d="M5.99999986,10.4086667 C6.00035625,10.8362438 6.25052412,11.2241753 6.6398695,11.4009025 C7.02921487,11.5776297 7.48591538,11.5105518 7.808,11.2293333 L11.4999999,8 L7.808,4.76866667 C7.48609102,4.4868368 7.02907003,4.41939751 6.63947861,4.59623639 C6.24988719,4.77307527 5.99978039,5.16148591 5.99999986,5.58933333 L5.99999986,10.4086667 Z"
                                    id="Shape"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
